import { Box, Button, Flex, Icon, Text } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";
import { FcCalendar } from "react-icons/fc";
import LessonScheduleFormPage from "../../new-request-flow/pages/SearchResultPage/NewLessonSchedulePage";
import { IRequestFlowStore } from "../../stores";
import { FormContainer } from "./components/FormWrapper";
import LessonSchedulePage from "./LessonSchedulePage";
import { ArrowBackIcon } from "@chakra-ui/icons";

type LessonScheduleSwitchProps = {
  viewModel: IRequestFlowStore["lessonScheduleStore"];
  scheduleStore?: IRequestFlowStore["scheduleStore"];
  isMultipleSchedule?: boolean;
  toggleLayout?: any;
  splitInfo: any;
  nextButtonText?: string;
  numberOfTeachers?: number;
  teacherOption?: string;
  loading?: boolean;
  onSubmit?: (data?: any) => Promise<any>;
  onScheduleSubmit?: (data?: any) => Promise<any>;
  onBack?: () => void;
  [key: string]: any;
};

export const LessonScheduleSwitcher: React.FC<LessonScheduleSwitchProps> =
  observer(
    ({
      viewModel,
      scheduleStore,
      isMultipleSchedule = false,
      toggleLayout,
      numberOfTeachers = 1,
      splitInfo,
      loading,
      teacherOption,
      nextButtonText="Next: Location",
      onBack,
      onSubmit,
      onScheduleSubmit,
      ...rest
    }) => {
      const formCopy = {
        heading: "When will lessons hold?",
        description:
          "To help us find available tutors, please let us know the best days and time to schedule your lessons.",
      };
      return (
        <FormContainer {...formCopy} {...rest}>
          {numberOfTeachers > 1 && (
            <ScheduleSwitchPrompt
              isMultiple={isMultipleSchedule}
              onClick={toggleLayout}
              numberOfTeachers={numberOfTeachers}
            />
          )}
          <Box>
            {isMultipleSchedule && scheduleStore && numberOfTeachers > 1 ? (
              <LessonScheduleFormPage
                splitInfo={splitInfo}
                loading={loading}
                viewModel={scheduleStore}
                submitText={nextButtonText}
                toNextPage={onScheduleSubmit}
              />
            ) : (
              <LessonSchedulePage
                loading={loading}
                viewModel={viewModel}
                numberOfTeachers={numberOfTeachers}
                submitText={nextButtonText}
                teacherOption={teacherOption}
                onSubmit={onSubmit}
                onBackClick={onBack}
              />
            )}
          </Box>
        </FormContainer>
      );
    }
  );

const ScheduleSwitchPrompt: React.FC<{
  onClick: () => void;
  isMultiple: boolean;
  numberOfTeachers: number;
  [key: string]: any;
}> = ({ onClick, isMultiple, numberOfTeachers, ...rest }) => {
  if (isMultiple) {
    return (
      <Button
        onClick={onClick}
        alignSelf={"flex-start"}
        variant="link"
        leftIcon={<ArrowBackIcon />}
        colorScheme="blue"
      >
        Back to general schedule
      </Button>
    );
  }
  return (
    <Flex
      px={[4, 5]}
      py={4}
      bg="neutral.100"
      borderColor="neutral.300"
      borderWidth={"2xs"}
      rounded="fbRadius"
      {...rest}
    >
      <Icon fontSize={"5xl"} ml={[0, 3]} mr={[4, 8]} as={FcCalendar} />
      <Box>
        <Text mb={2} fontSize="md" fontWeight="semibold">
          Do you want to set schedules for each of the {numberOfTeachers}{" "}
          tutors?
        </Text>
        <Button
          size="sm"
          onClick={onClick}
          colorScheme={"blue"}
          variant={"link"}
        >
          Click to set schedules
        </Button>
      </Box>
    </Flex>
  );
};
